<template>
  <section>
    <div>
      <router-link :to="{ path: '/farms' }">
        <mdb-icon icon="arrow-left" size="lg" />
        Back to Farms
      </router-link>
    </div>
    <farm-detail-form :farm-id="activeFarmId" :farm-data="farmData" @savedFarm="getFarm" />
    <Table :headers="fieldsHeader" title="Fields">
      <div slot="header">
        <h5>Total Arces: {{ totalArces }}</h5>
        <mdb-btn
          color="primary"
          class="float-right"
          @click="fieldFormModal = true"
        >
          Add Field
        </mdb-btn>
      </div>
      <tbody slot="rows">
        <tr v-for="(field, index) in farmFields" :key="index">
          <td>
            <router-link
              :to="{ path: `/farms/${activeFarmId}/field/${field.id}` }"
            >
              {{ field.name }}
            </router-link>
          </td>
          <td>{{ field.arces }}</td>
          <td>{{ field.type }}</td>
          <td>{{ field.services | length }}</td>
          <td v-if="field.isActive">
            Yes
          </td>
          <td v-else>
            No
          </td>
        </tr>
      </tbody>
    </Table>
    <Table :headers="fieldServicesHeader" title="Field Services">
      <div slot="header">
        <mdb-btn
          color="primary"
          class="float-right"
          @click="fieldServiceFormModal = true"
        >
          Add Field Service
        </mdb-btn>
      </div>
      <tbody slot="rows">
        <tr v-for="(service, index) in fieldServices" :key="index">
          <td>
            <a @click="openServiceForm(service)">#{{ service.reference }} - {{ service.servicesSummary }}</a>
          </td>
          <td>{{ service.fieldName }}</td>
          <td>{{ service.startDatetime | dateFormat }}</td>
          <td>{{ service.endDatetime | dateFormat }}</td>
        </tr>
      </tbody>
    </Table>
    <Map :address="fullAddress" />
    <mdb-row class="mt-5">
      <mdb-col md="12">
        <mdb-card cascade narrow>
          <mdb-btn color="danger" block @click="farmDeleteModal = true">
            Delete Farm
          </mdb-btn>
        </mdb-card>
      </mdb-col>
    </mdb-row>
    <mdb-modal :show="fieldFormModal" size="lg" @close="closeAllModals()">
      <mdb-modal-header>
        <mdb-modal-title>New Field Form</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <validated-form :message="fieldFormMessage" @submit="saveField">
          <mdb-modal-body>
            <mdb-input
              v-model="fieldData.name"
              size="lg"
              label="Field No."
              type="text"
              outline
              required
            />
            <mdb-input
              v-model="fieldData.arces"
              size="lg"
              label="Arces"
              type="number"
              outline
            />
            <mdb-input
              v-model="fieldData.type"
              size="lg"
              label="Field Type"
              type="text"
              outline
            />
            <div class="form-check">
              <input
                id="isActiveCheckbox"
                v-model="fieldData.isActive"
                type="checkbox"
                class="form-check-input"
              />
              <label class="form-check-label pl-2" for="isActiveCheckbox">Is Active?</label>
            </div>
          </mdb-modal-body>
          <mdb-modal-footer>
            <mdb-btn color="primary" type="submit">
              Save
            </mdb-btn>
          </mdb-modal-footer>
        </validated-form>
      </mdb-modal-body>
    </mdb-modal>
    <mdb-modal
      :show="fieldServiceFormModal"
      size="lg"
      @close="closeAllModals()"
    >
      <mdb-modal-header>
        <mdb-modal-title>Field Service Form</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <field-service-form
          :farm-id="activeFarmId"
          :field-id="activeFieldId"
          :service-id="activeServiceId"
          @savedService="closeAllModals()"
        />
      </mdb-modal-body>
    </mdb-modal>
    <mdb-modal :show="farmDeleteModal" size="lg" @close="closeAllModals()">
      <mdb-modal-header>
        <mdb-modal-title>Delete Farm?</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        Are you sure you want to delete this farm and all of it's data? This
        action can not be reversed.
      </mdb-modal-body>
      <mdb-modal-footer>
        <mdb-btn color="danger" @click.native="deleteFarm()">
          Delete
        </mdb-btn>
        <mdb-btn color="primary" @click.native="farmDeleteModal = false">
          Close
        </mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
  </section>
</template>

<script>
import {
  mdbBtn,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbInput,
  mdbIcon
} from "mdbvue";
import FarmDetailForm from "../components/FarmDetailForm";
import FieldServiceForm from "../components/FieldServiceForm";
import Map from "@/components/Map";
import Table from "@/components/Table";
import ValidatedForm from "@/components//ValidatedForm";
import { farmsModel } from "../models/farm";
import { fieldsModel } from "../models/field";

export default {
  name: "FarmOverview",
  components: {
    mdbBtn,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbRow,
    mdbCol,
    mdbCard,
    Map,
    Table,
    FarmDetailForm,
    FieldServiceForm,
    ValidatedForm,
    mdbInput,
    mdbIcon
  },
  filters: {
    length: function(arr) {
      const array = arr || [];
      return array.length;
    }
  },
  data() {
    return {
      activeFarmId: "",
      activeFieldId: "",
      activeServiceId: "",
      farmDeleteModal: false,
      totalArces: 0,
      fieldFormModal: false,
      fieldFormMessage: {},
      fieldServiceFormModal: false,
      fieldsHeader: [
        "Field No.",
        "Arces",
        "Type",
        "Service Count",
        "Is Active"
      ],
      fieldServicesHeader: [
        "Service Id",
        "Field No.",
        "Start Date",
        "End Date"
      ],
      fieldServices: [],
      fullAddress: "",
      farmData: {
        id: "",
        name: "",
        address: "",
        city: "",
        state: "",
        postalCode: "",
        isActive: true,
        updatedAt: "",
        createdAt: "",
        createdBy: ""
      },
      farmFields: [],
      fieldData: {
        farmId: "",
        farmName: "",
        name: "",
        arces: 0,
        type: "",
        services: [],
        isActive: true
      }
    };
  },
  beforeMount() {
    this.activeFarmId = this.$route.params.id;
    this.getFarm().catch(() => this.$router.push("/farms"));
  },
  methods: {
    getFullAddress() {
      const data = this.farmData;
      this.fullAddress = `${data.address} ${data.city}, ${data.state} ${data.postalCode}`;
    },
    openServiceForm(service) {
      this.activeServiceId = service.id;
      this.activeFieldId = service.fieldId;
      this.fieldServiceFormModal = true;
    },
    closeAllModals() {
      this.fieldFormModal = false;
      this.fieldServiceFormModal = false;
      this.activeServiceId = "";
      this.activeFieldId = "";
      this.getFarm();
    },
    getFarm() {
      return farmsModel
        .get(this.activeFarmId)
        .then(farm => {
          this.farmData = farm;
          this.fieldData.farmName = farm.name;
          this.fieldData.farmId = farm.id;
          this.getFullAddress();
        })
        .then(() => this.getFarmFields());
    },
    getFarmFields() {
      return fieldsModel
        .getFields(this.activeFarmId)
        .then(fields => {
          this.farmFields = fields;
        })
        .then(() => {
          this.fieldServices = fieldsModel.getAllFieldServices(this.farmFields);
          this.totalArces = fieldsModel.getTotalArces(this.farmFields);
        });
    },
    deleteFarm() {
      return farmsModel
        .remove(this.activeFarmId)
        .then(() => this.$router.push("/farms"));
    },
    saveField() {
      this.fieldFormMessage = {};
      fieldsModel
        .create(this.fieldData)
        .then(() => {
          this.fieldData = { isActive: true };
          this.closeAllModals();
        })
        .catch(() => {
          this.fieldFormMessage = {
            type: "danger",
            message: "There was a problem updating. Please try again"
          };
        });
    }
  }
};
</script>
